/**
 * Open a URL in a new tab securely with fallback
 * @param {string} url - The URL to open
 */
export const openInNewTab = (url) => {
    if (!url) return;

    const newWindow = window.open(url, '_blank');
    !newWindow ? (window.location.href = url) : (newWindow.opener = null);
};
